import { useTranslation } from "react-i18next";
import { Loader2, Mic, MicOff, Gift } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export default function SafeRouteDestinationInput({
  dest,
  onChange,
  onSubmit,
  busy,
  freeAvailable,
  voiceSupported,
  listening,
  onStartVoice,
  onStopVoice,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex gap-2">
        <Input
          value={dest}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") onSubmit(); }}
          placeholder={voiceSupported ? t("safe_route.destination_placeholder") : t("safe_route.destination_placeholder_no_voice")}
          className="rounded-sm font-body text-sm"
          data-testid="safe-route-dest-input"
        />
        {voiceSupported && (
          <Button
            type="button"
            onClick={listening ? onStopVoice : onStartVoice}
            disabled={busy}
            data-testid="safe-route-voice-btn"
            variant="outline"
            className={`rounded-sm shrink-0 px-2 ${listening ? "bg-red-50 text-red-700 border-red-200" : ""}`}
            aria-label={listening ? t("safe_route.voice_stop") : t("safe_route.voice_start")}
            title={listening ? t("safe_route.voice_tooltip_listening") : t("safe_route.voice_tooltip_idle")}
          >
            {listening ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
          </Button>
        )}
        <Button
          onClick={onSubmit}
          disabled={busy}
          data-testid="safe-route-find-btn"
          className="bg-black hover:bg-gray-800 text-white rounded-sm font-body text-sm shrink-0"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : t("safe_route.advise")}
        </Button>
      </div>
      {freeAvailable === true ? (
        <p
          className="inline-flex items-center gap-1 text-[10px] font-body font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-sm px-1.5 py-0.5"
          data-testid="safe-route-free-chip"
        >
          <Gift className="w-3 h-3" /> {t("safe_route.free_left")}
        </p>
      ) : (
        <p className="text-[10px] text-gray-400 font-body" data-testid="safe-route-price-note">
          {freeAvailable === false ? t("safe_route.free_used") : t("safe_route.price_note")}
        </p>
      )}
      {listening && (
        <p className="text-[11px] text-red-700 font-body inline-flex items-center gap-1.5" data-testid="safe-route-listening">
          <span className="relative inline-flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
          </span>
          {t("safe_route.listening")}
        </p>
      )}
    </>
  );
}
